import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

export const RlhContainer = styled.div<{
  isEmpty?: boolean
  isCanceled?: boolean
}>`
  display: ${props => (props.isEmpty && !props.isCanceled ? 'block' : 'grid')};
  grid-template-columns: 1fr 1fr;
  width: 100%;
  align-items: center;
  padding-bottom: 1rem;
  padding-top: 1.5rem;

  p {
    margin-top: 1rem;
    grid-row: 2;
    grid-column: 1 / span 2;
  }

  @media ${mediaQueries.desktop} {
    padding: 1.5rem 0 1rem 0;
    grid-template-columns: 1fr min-content;
    margin: 0;

    p {
      margin: 0;
      grid-row: 2;
      grid-column: 1;
    }
  }
`
